import Vue from 'vue'
import Vuex from 'vuex'
import {deepClone} from '@/util'
Vue.use(Vuex)

const state = {
  authUser: null,
  activeNav: '我的兑换码',
  //菜单列表
  menuList: [],
  currentRemoveRoutes:[],
  isGenerate: false,
}

function flatAsyncRoutes(routes) {
  let res = []
  routes.forEach(route => {
    if (route.children) {
      let tmpRoute = deepClone(route);
      delete tmpRoute.children;
      res.push(tmpRoute)
      let childrenRoutes = flatAsyncRoutes(route.children);
      childrenRoutes.map(item => {
        // 如果 path 一样则覆盖，因为子路由的 path 可能设置为空，导致和父路由一样，直接注册会提示路由重复
        if (res.some(v => v.path == item.path)) {
          res.forEach((v, i) => {
            if (v.path == item.path) {
              res[i] = item
            }
          })
        } else {
          res.push(item)
        }
      })
    }
    else {
      let tmpRoute = deepClone(route);
      res.push(tmpRoute);
    }
  });
  return res
}

function hasPermission(permissions, route) {
  let isAuth = false
  if (route.meta && route.meta.auth) {
    isAuth = permissions.some(auth => {
      if (typeof route.meta.auth == 'string') {
        return route.meta.auth === auth
      } else {
        return route.meta.auth.some(routeAuth => {
          return routeAuth === auth
        })
      }
    })
  } else {
    isAuth = true
  }
  return isAuth
}

function filterAsyncRoutes(routes, permissions) {
  const res = []
  routes.forEach(route => {
    let tmpRoute = deepClone(route);
    if (hasPermission(permissions, tmpRoute)) {
      if (tmpRoute.children) {
        tmpRoute.children = filterAsyncRoutes(tmpRoute.children, permissions)
        tmpRoute.children.length && res.push(tmpRoute)
      } else {
        res.push(tmpRoute)
      }
    }
  })
  return res
}

const mutations = {
  SET_USER: function (state, user) {
    state.authUser = user
  },
  setActNav: function (state, str) {
    state.activeNav = str
  },
  commitMenuList(state, data) {
    let menu = [
      ...data
    ];
    state.menuList = menu;
  },
  setIsGenerate(state, data) {
    state.isGenerate = data;
  }
}
const getters = {
  getTabStatus: state => {
    let status = ""
    if (state.activeNav === '我的兑换码') {
      status = 'first'
    }
    if (state.activeNav === '制作推广海报') {
      status = 'second'
    }
    return status
  },
  getLocalUser: state => {
    return state.authUser || JSON.parse(localStorage.getItem("userinfo"));
  },
  agentAble: (state, getters) => {
    return getters.getLocalUser.agent;
  },
  root: (state, getters) => {
    return getters.getLocalUser.root;
  },
  userId: (state, getters) => {
    return getters.getLocalUser.userId;
  },
  userName: (state, getters) => {
    return getters.getLocalUser.userName;
  },
  rechargeButton: (state, getters) => {
    return getters.getLocalUser.rechargeButton;
  }
}
const actions = {
  setLocalUser({
                 commit
               }, user) {
    localStorage.setItem("userinfo", JSON.stringify(user));
    commit('SET_USER', user);
  },
  clearLocalUser({
                   commit
                 }) {
    localStorage.clear();
    commit('SET_USER', null);
  },
  generateRoutesAtFront(context,asyncRoutes) {
    return new Promise(async resolve => {

      //后期这里可以进行权限控制
      //.....
      // let accessedRoutes;
      // const permissions = [];
      // accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions);

      //组装菜单数据
      let menuLists = deepClone(asyncRoutes);
      context.commit("commitMenuList", menuLists);

      // 将多级拍成平级
      let Routes = asyncRoutes;
      Routes.map(item=>{
        if(item.children && item.children.length){
          item.children = flatAsyncRoutes(item.children);
        }
      });
      resolve(Routes)
    })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js